import { render, staticRenderFns } from "./Deskingsetting.vue?vue&type=template&id=141371ae&scoped=true"
import script from "./Deskingsetting.vue?vue&type=script&lang=js"
export * from "./Deskingsetting.vue?vue&type=script&lang=js"
import style0 from "./Deskingsetting.vue?vue&type=style&index=0&id=141371ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141371ae",
  null
  
)

export default component.exports